import { Asterisk } from "lucide-react";

const ITEMS = [
  "THE ART OF THE STEAL",
  "WEAPONS OF MASS CREATION",
  "WHERE CHAOS MEETS DATA",
  "UNCHARTED → CHARTED",
  "SELECT SATURDAYS // GREEN COAST RADIO",
  "DON'T SIGN BLIND. SIGN SMART.",
  "EST. MMVI // SAN DIEGO",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div
      className="relative border-y border-[#22222B] bg-[#0C0C10] py-5 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track flex items-center gap-10 whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-display uppercase text-xl sm:text-2xl tracking-wide text-[#F2F2F5]/80">
                  {item}
                </span>
                <Asterisk className="h-5 w-5 text-[#CCFF00]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
